import { Link } from "react-router-dom";
import { AlertCircle, ArrowRight, Wrench } from "lucide-react";

export default function ReportBanner() {
    return (
        <section className="py-12 md:py-16 px-6 lg:px-10 bg-[#FAF8F3]" data-testid="report-banner-section">
            <div className="max-w-6xl mx-auto">
                <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#0D4F3C] via-[#0D4F3C] to-[#092E22] shadow-xl">
                    {/* Decorative blob */}
                    <div className="absolute -right-12 -top-12 w-72 h-72 bg-[#D4A537]/10 rounded-full blur-3xl pointer-events-none" />
                    <div className="absolute -left-8 -bottom-8 w-56 h-56 bg-[#D4A537]/5 rounded-full blur-2xl pointer-events-none" />

                    <div className="relative grid md:grid-cols-3 gap-6 md:gap-10 items-center p-6 md:p-10">
                        <div className="flex md:block items-center gap-4 md:col-span-2">
                            <div className="shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-[#D4A537]/20 ring-1 ring-[#D4A537]/40 flex items-center justify-center mb-0 md:mb-4">
                                <Wrench className="text-[#D4A537]" size={28} />
                            </div>
                            <div>
                                <div className="flex items-center gap-2 text-[#D4A537] text-[10px] md:text-xs uppercase tracking-[0.3em] font-semibold mb-1 md:mb-2">
                                    <AlertCircle size={12} /> Zauważyłeś problem?
                                </div>
                                <h3 className="font-serif text-2xl md:text-4xl text-white leading-tight">
                                    Zgłoś usterkę na osiedlu
                                </h3>
                                <p className="text-white/70 text-sm md:text-base mt-2 md:mt-3 max-w-xl leading-relaxed hidden md:block">
                                    Zauważyłeś awarię windy, oświetlenia, hałas, problemy z parkingiem lub coś innego?
                                    Wyślij zgłoszenie — trafi bezpośrednio do administracji i odpowiedniego podmiotu.
                                </p>
                            </div>
                        </div>

                        <div className="flex md:justify-end">
                            <Link
                                to="/zglos-usterke"
                                className="group inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-4 bg-[#D4A537] hover:bg-[#E5B649] text-[#092E22] font-semibold text-sm md:text-base rounded-full shadow-lg transition-all hover:scale-[1.03] w-full md:w-auto justify-center"
                                data-testid="report-banner-cta"
                            >
                                Zgłoś teraz
                                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
